import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import './styles.css';

const renderField = ({
  selectData,
  feedbackIcon,
  input,
  label,
  type,
  min,
  max,
  meta: { visited, touched, error, warning, asyncValidating }
}) => {
  const style = { marginTop: '15px' };
  const selectStyle = { color: 'black', textAlignLast: 'center', marginTop: '15px' };
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;

  const selectControl = () => {
    const result = selectData.map((val, index) => (
      <option value={val.value} key={index}>
        {val.label}
      </option>
    ));
    return (
      <div>
        <FormControl {...input} componentClass="select" style={selectStyle}>
          <option value="">{label}</option>
          {result}
        </FormControl>
      </div>
    );
  };
  
  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <div>
        {type === 'select' ? (
          selectControl()
        ) : (
          <div>
            <FormControl {...input} placeholder={label} type={type} style={style} min={min} max={max} />
            {asyncValidating ? (
              <FormControl.Feedback style={{ width: 'inherit', height: 'inherit', right: '25px', top: '10px' }}>
                <i className="fa fa-spinner fa-spin" />
              </FormControl.Feedback>
            ) : null}
          </div>
        )}
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched && error && <span className="help-block">{error}</span>}
      </div>
    </FormGroup>
  );
};

export default renderField;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/renderField.js